import React from 'react'

import BrassPanel from '../../../components/BrassPanel'

function MachineTime({timeRemaining, maxTime}) {
    
    function timeBlocks() {
        const totalBlocks = 60
        const timePerBlock = maxTime / totalBlocks
        const blocksToShow = timeRemaining < maxTime ? Math.ceil(timeRemaining / timePerBlock) : totalBlocks
        const blockArr = []
        for (let i=0; i < blocksToShow; i++) {
            const classStr = i < (totalBlocks * 0.15) ? 'machine_time_block-red' : ''
            blockArr.push(
                <div
                    key={i}
                    className={`machine_time_block ${classStr}`}
                ></div>
            )
        }        
        return blockArr
    } 
    
    return (
        <BrassPanel extraClasses='machine_panel machine_panel-time'>
            <i className="fas fa-exclamation-triangle machine_time_icon"></i>
            <div className='machine_timeDisplay'>
                {timeBlocks()}
            </div>
        </BrassPanel>
    )
}

export default MachineTime